import * as d3 from 'd3'
import emptyThumb from '../../assets/images/emptydata.svg'
import Chart from '../../ultils/Chart'
import './styles.css'
import d3tip from '../../ultils/d3-tip'
import { countYAxisTick } from '../../ultils/chart-d3-utils'

class AreaChart extends Chart {
  init({ data, yKey, inModal }) {
    let vis = this
    vis.data = data
    vis.yKey = yKey
    vis.inModal = inModal

    vis.bisectDate = d3.bisector(d => d.date).left

    vis.lg = vis.svg
      .append('defs')
      .append('linearGradient')
      .attr('id', 'mygrad')
      .attr('x1', '0%')
      .attr('x2', '0%')
      .attr('y1', '0%')
      .attr('y2', '100%')

    vis.lg
      .append('stop')
      .attr('offset', '0%')
      .style('stop-color', '#3393F3')
      .style('stop-opacity', 0.4)

    vis.lg
      .append('stop')
      .attr('offset', '100%')
      .style('stop-color', '#3393F3')
      .style('stop-opacity', 0)

    vis.areaPath = vis.g
      .append('path')
      .attr('class', 'area')
      .style('fill', 'url(#mygrad)')

    vis.linePath = vis.g
      .append('path')
      .attr('fill', 'none')
      .attr('stroke', '#3393F3')
      .attr('stroke-width', '2px')

    vis.x = d3.scaleTime()
    vis.y = d3.scaleLinear()

    vis.xAxisCall = d3
      .axisBottom()
      .ticks(inModal ? 8 : 2)
      .tickSizeOuter(0)
      .tickFormat(d3.timeFormat('%Y'))
    vis.yAxisCall = d3
      .axisLeft()
      .ticks(inModal ? 6 : 4)
      .tickSizeOuter(0)

    vis.xAxis = vis.g
      .append('g')
      .attr('class', 'x axisAreaChart')
      .attr('transform', `translate(0, ${vis.HEIGHT})`)
    vis.yAxis = vis.g.append('g').attr('class', 'y axisAreaChart')

    vis.yLegend = vis.svg
      .append('text')
      .attr('class', inModal ? 'axis-label label-in-modal' : 'axis-label')
      .attr('text-anchor', 'end')
      .attr('x', inModal ? 70 : 60)
      .attr('y', 10)

    vis.focus = vis.g
      .append('g')
      .attr('class', 'focus')
      .style('display', 'none')

    vis.focus
      .append('line')
      .attr('class', 'x-hover-line hover-line')
      .attr('y1', 0)
      .attr('y2', vis.HEIGHT)

    vis.createToolTip()
    vis.update({ data })
  }

  formatNumber(number) {
    return !isNaN(number) ? Number(number).toFixed(2) : number
  }

  createToolTip() {
    const vis = this
    const inModal = vis.inModal ? '-inModal' : '-notInModal'
    d3.selectAll(`.line-chart${vis.yKey}${inModal}`).remove()
    vis.tip = d3tip()
      .attr('class', `d3-tip-line-chart line-chart${vis.yKey}${inModal}`)
      .html((e, d) => vis.generateTooltipHtml(d))
    vis.g.call(vis.tip)
  }

  generateTooltipHtml(data) {
    const vis = this
    let returnDiv = `<div class="tip-content">`
    returnDiv += `<div class="row">
                      <div class="line-chart-row-title">
                        <span class="dot" style="background-color: #3393F3;"></span> Index value: 
                      </div>
                      <div class="line-chart-row-content">${vis.formatNumber(
                        data[vis.yKey],
                      )}</div>
                    </div>`
    returnDiv += `</div></div></div>`
    return returnDiv
  }

  mousemove(e) {
    let vis = this
    if (vis.data.length > 0) {
      const x0 = vis.x.invert(d3.pointer(e)[0] - vis.MARGIN.LEFT)
      const i = vis.bisectDate(vis.data, x0, 1, vis.data.length - 1)
      const d0 = vis.data[i - 1]
      const d1 = vis.data[i]
      const d = x0 - d0.date > d1.date - x0 ? d1 : d0

      vis.focus
        .select('.x-hover-line')
        .attr('x1', vis.x(d.date))
        .attr('x2', vis.x(d.date))

      vis.focus.selectAll('circle').remove()
      vis.focus
        .append('circle')
        .attr('class', 'companyHistory')
        .attr('r', 4)
        .attr('fill', '#3393F3')

      vis.focus
        .select('.companyHistory')
        .attr('cx', vis.x(d.date))
        .attr('cy', vis.y(d[vis.yKey]))

      vis.tip.show(e, d, 10, -d3.pointer(e)[1] - 40)
    }
  }

  update({ data }) {
    let vis = this
    vis.data = data || vis.data
    vis.svg.selectAll('image').remove()

    if (vis.data.length <= 1) {
      vis.data = []
      vis.svg
        .append('svg:image')
        .attr('xlink:href', emptyThumb)
        .attr('x', vis.WIDTH / 2 - 77 + vis.MARGIN.LEFT)
        .attr('y', vis.HEIGHT / 2 - 37 + vis.MARGIN.TOP)
        .attr('width', '155')
        .attr('height', '73')
    } else {
      vis.yLegend.text('Index')
    }

    vis.t = d3.transition().duration(1000)

    vis.x.range([0, vis.WIDTH]).domain(d3.extent(vis.data, d => d.date))
    vis.y
      .range([vis.HEIGHT, 0])
      .domain([0, d3.max(vis.data, d => Number(d[vis.yKey]))])

    vis.xAxisCall = d3
      .axisBottom()
      .ticks(countYAxisTick(vis.data))
      .tickSizeOuter(0)

    vis.xAxisCall.scale(vis.x)
    vis.xAxis.transition(vis.t).call(vis.xAxisCall)
    vis.yAxisCall.scale(vis.y)
    vis.yAxis.transition(vis.t).call(vis.yAxisCall)

    vis.area = d3
      .area()
      .curve(d3.curveCatmullRom)
      .x(d => vis.x(d.date))
      .y0(d => vis.y(0))
      .y1(d => vis.y(d[vis.yKey]))

    vis.line = d3
      .line()
      .curve(d3.curveCatmullRom)
      .x(d => vis.x(d.date))
      .y(d => vis.y(d[vis.yKey]))

    vis.areaPath.transition(vis.t).attr('d', vis.area(vis.data))
    vis.linePath.transition(vis.t).attr('d', vis.line(vis.data))

    vis.svg
      .on('mousemove', e => vis.mousemove(e))
      .on('mouseover', () => {
        // vis.tip.hide()
        vis.focus.style('display', null)
      })
      .on('mouseout', () => {
        vis.tip.hide()
        vis.focus.style('display', 'none')
      })
  }
}

export default AreaChart
